import { render, staticRenderFns } from "./add-file.vue?vue&type=template&id=897bc8c4&scoped=true"
import script from "./add-file.vue?vue&type=script&lang=js"
export * from "./add-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897bc8c4",
  null
  
)

export default component.exports